<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
body{
  font-family: "DejaVu Sans"
}
</style>



// WEBPACK FOOTER //
// src/App.vue